var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUsage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.885,
    height: 100,
    viewBox: "0 0 120.885 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6e6e6;}.b,.d,.m{opacity:0.1;}.c,.d{fill:#fbae47;}.e{fill:url(#a);}.f{fill:#535461;}.g{fill:#fff;}.h{fill:#f6f7f9;}.i{opacity:0.2;}.j{fill:#dce0ed;}.k{fill:#2f2e41;}.l{fill:#f8d7d7;}.m{fill:#2e2e2d;}.n{fill:#ec008c;}.o{fill:#ec168c;}.p{fill:#3f3d56;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.021)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.509,31.695c-3.557-.129-7.273-.219-10.489,1.28s-5.7,5.131-4.624,8.469a16.043,16.043,0,0,0,1.616,3.028,17.2,17.2,0,0,1,.345,16.43c-2.063,3.9-5.56,6.872-8.077,10.508s-3.948,8.675-1.472,12.337c1.7,2.508,4.842,3.728,7.891,4.024s6.114-.17,9.176-.29a40.12,40.12,0,0,1,17.353,3.226c7.52,3.241,14,8.786,21.917,10.926a6.73,6.73,0,0,0,2.916.29c1.724-.309,2.978-1.71,4.328-2.817,4.309-3.508,10.275-4.163,15.868-4.326s11.419-.037,16.475-2.4a21.551,21.551,0,0,0,9.926-10.228,37.886,37.886,0,0,0,3.377-13.939,19.471,19.471,0,0,0-.841-8.469c-1.168-3-3.536-5.394-6.019-7.485a29.417,29.417,0,0,0-8.628-5.344c-3.827-1.408-7.982-1.61-12.057-1.944a168.255,168.255,0,0,1-24.8-3.915c-7.739-1.819-16.237-3.806-23.285-7.511C90.867,31.688,87.5,31.836,83.509,31.695Z",
    transform: "translate(-59.52 -46.101)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(71.177 31.067)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M773.4,533.659s.356-4.991,3.165-7.712a7.579,7.579,0,0,0,2.239-4.24,12.81,12.81,0,0,0,.151-2.327",
    transform: "translate(-771.559 -516.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M827.74,489.375c-.206.551-1.8,1.777-1.8,1.777a8.368,8.368,0,0,1-.194-2.522,1.065,1.065,0,0,1,1.995.745Z",
    transform: "translate(-818.584 -487.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M829.027,521.674a8.46,8.46,0,0,1-2.477.512,8.439,8.439,0,0,1,1.207-2.223,1.065,1.065,0,0,1,1.27,1.71Z",
    transform: "translate(-819.362 -516.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M809.647,571.368a8.452,8.452,0,0,1-2.4-.8,8.394,8.394,0,0,1,2.164-1.308,1.064,1.064,0,0,1,.233,2.113Z",
    transform: "translate(-802.004 -561.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M784.749,607.119a8.449,8.449,0,0,1-2.5-.391,8.439,8.439,0,0,1,1.911-1.656,1.065,1.065,0,1,1,.588,2.047Z",
    transform: "translate(-779.518 -593.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M804.523,523.712a8.439,8.439,0,0,0,1.943,1.617,8.413,8.413,0,0,0-.019-2.529,1.065,1.065,0,0,0-1.924.912Z",
    transform: "translate(-799.47 -518.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M775.268,563.069a8.494,8.494,0,0,0,2.339.962,8.442,8.442,0,0,0-.775-2.408,1.065,1.065,0,0,0-1.564,1.447Z",
    transform: "translate(-772.984 -553.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M755.253,609.051a8.442,8.442,0,0,0,2.143,1.343,8.425,8.425,0,0,0-.357-2.5,1.065,1.065,0,0,0-1.786,1.161Z",
    transform: "translate(-755.097 -595.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M827.74,489.375c-.206.551-1.8,1.777-1.8,1.777a8.368,8.368,0,0,1-.194-2.522,1.065,1.065,0,0,1,1.995.745Z",
    transform: "translate(-818.584 -487.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M829.027,521.674a8.46,8.46,0,0,1-2.477.512,8.439,8.439,0,0,1,1.207-2.223,1.065,1.065,0,0,1,1.27,1.71Z",
    transform: "translate(-819.362 -516.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M809.647,571.368a8.452,8.452,0,0,1-2.4-.8,8.394,8.394,0,0,1,2.164-1.308,1.064,1.064,0,0,1,.233,2.113Z",
    transform: "translate(-802.004 -561.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M784.749,607.119a8.449,8.449,0,0,1-2.5-.391,8.439,8.439,0,0,1,1.911-1.656,1.065,1.065,0,1,1,.588,2.047Z",
    transform: "translate(-779.518 -593.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M804.523,523.712a8.439,8.439,0,0,0,1.943,1.617,8.413,8.413,0,0,0-.019-2.529,1.065,1.065,0,0,0-1.924.912Z",
    transform: "translate(-799.47 -518.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M775.268,563.069a8.494,8.494,0,0,0,2.339.962,8.442,8.442,0,0,0-.775-2.408,1.065,1.065,0,0,0-1.564,1.447Z",
    transform: "translate(-772.984 -553.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M755.253,609.051a8.442,8.442,0,0,0,2.143,1.343,8.425,8.425,0,0,0-.357-2.5,1.065,1.065,0,0,0-1.786,1.161Z",
    transform: "translate(-755.097 -595.409)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(72.148 11.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M783.2,345.879s.356-4.991,3.165-7.712a7.584,7.584,0,0,0,2.239-4.24,12.635,12.635,0,0,0,.151-2.327",
    transform: "translate(-781.326 -328.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M837.545,301.6c-.2.55-1.8,1.776-1.8,1.776a8.387,8.387,0,0,1-.2-2.521,1.065,1.065,0,1,1,1.995.745Z",
    transform: "translate(-828.356 -300.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M838.857,333.586a8.422,8.422,0,0,1-2.477.512,8.431,8.431,0,0,1,1.207-2.222,1.065,1.065,0,1,1,1.27,1.71Z",
    transform: "translate(-829.156 -328.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M819.456,383.545a8.453,8.453,0,0,1-2.4-.8,8.425,8.425,0,0,1,2.164-1.308,1.065,1.065,0,1,1,.232,2.118Z",
    transform: "translate(-811.78 -373.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M794.549,419.407a8.45,8.45,0,0,1-2.5-.391,8.484,8.484,0,0,1,1.911-1.657,1.065,1.065,0,1,1,.587,2.048Z",
    transform: "translate(-789.286 -405.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M814.21,335.679a8.422,8.422,0,0,0,1.945,1.618,8.451,8.451,0,0,0-.019-2.529,1.065,1.065,0,1,0-1.926.912Z",
    transform: "translate(-809.124 -330.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M785.234,375.463a8.462,8.462,0,0,0,2.34.962,8.435,8.435,0,0,0-.776-2.407,1.065,1.065,0,0,0-1.564,1.446Z",
    transform: "translate(-782.917 -366.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M764.761,420.82a8.457,8.457,0,0,0,2.143,1.343,8.425,8.425,0,0,0-.357-2.5,1.065,1.065,0,1,0-1.786,1.161Z",
    transform: "translate(-764.572 -407.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M837.545,301.6c-.2.55-1.8,1.776-1.8,1.776a8.387,8.387,0,0,1-.2-2.521,1.065,1.065,0,1,1,1.995.745Z",
    transform: "translate(-828.356 -300.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M838.857,333.586a8.422,8.422,0,0,1-2.477.512,8.431,8.431,0,0,1,1.207-2.222,1.065,1.065,0,1,1,1.27,1.71Z",
    transform: "translate(-829.156 -328.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M819.456,383.545a8.453,8.453,0,0,1-2.4-.8,8.425,8.425,0,0,1,2.164-1.308,1.065,1.065,0,1,1,.232,2.118Z",
    transform: "translate(-811.78 -373.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M794.549,419.407a8.45,8.45,0,0,1-2.5-.391,8.484,8.484,0,0,1,1.911-1.657,1.065,1.065,0,1,1,.587,2.048Z",
    transform: "translate(-789.286 -405.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M814.21,335.679a8.422,8.422,0,0,0,1.945,1.618,8.451,8.451,0,0,0-.019-2.529,1.065,1.065,0,1,0-1.926.912Z",
    transform: "translate(-809.124 -330.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M785.234,375.463a8.462,8.462,0,0,0,2.34.962,8.435,8.435,0,0,0-.776-2.407,1.065,1.065,0,0,0-1.564,1.446Z",
    transform: "translate(-782.917 -366.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M764.761,420.82a8.457,8.457,0,0,0,2.143,1.343,8.425,8.425,0,0,0-.357-2.5,1.065,1.065,0,1,0-1.786,1.161Z",
    transform: "translate(-764.572 -407.179)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M232.93,760.785c4.929,1.419,10.945.555,16.538.656a6.543,6.543,0,0,1,2.191.3,4.873,4.873,0,0,1,1.338.984c1.567,1.267,4.779,1.674,7.586,1.459a63.763,63.763,0,0,0,8.032-1.468c4.579-.937,9.814-1.363,14.331-.342a4.288,4.288,0,0,0,1.3.164c.99-.083,1.285-.763,1.978-1.151,1.25-.7,3.966-.51,4.515-1.433.322-.541-.419-1.1-1.225-1.466-3.086-1.413-7.5-1.647-11.544-1.428s-8.013.819-12.072.822c-5.06,0-9.949-.922-14.96-1.3a35.576,35.576,0,0,0-10.513.543C236.894,757.958,236.116,759.832,232.93,760.785Z",
    transform: "translate(-215.485 -697.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M298.788,67.32h-46.74a4.281,4.281,0,0,0-4.288,4.274v64.758a4.281,4.281,0,0,0,4.288,4.271h46.74a4.281,4.281,0,0,0,4.288-4.274V71.594A4.281,4.281,0,0,0,298.788,67.32Z",
    transform: "translate(-228.266 -78.201)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 53.993,
    height: 71.771,
    rx: 20,
    transform: "translate(20.16 -10.003)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 48.507,
    height: 58.193,
    transform: "translate(22.933 -3.215)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 0.659,
    cy: 0.659,
    r: 0.659,
    transform: "translate(46.442 -8.551)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.976,
    cy: 1.976,
    r: 1.976,
    transform: "translate(45.12 56.281)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(22.933 -4.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 48.507,
    height: 2.9
  })), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 0.619,
    cy: 0.619,
    r: 0.619,
    transform: "translate(23.607 -3.484)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 0.619,
    cy: 0.619,
    r: 0.619,
    transform: "translate(25.209 -3.484)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 0.619,
    cy: 0.619,
    r: 0.619,
    transform: "translate(26.809 -3.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 45.17,
    height: 0.151,
    transform: "translate(24.391 13.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 45.17,
    height: 0.151,
    transform: "translate(24.391 16.601)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 45.17,
    height: 0.151,
    transform: "translate(24.391 20.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 45.17,
    height: 0.151,
    transform: "translate(24.391 23.721)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 45.17,
    height: 0.151,
    transform: "translate(24.391 27.28)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(24.335 15.315)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M281.135,315.21H235.91v-6.891l4.148,2.044,4.293.582,3.766-1.136,4.544-3.524,2.286-1.32,1.671-.322,1.6.086,2.629,1.3,3.574,2.277,2.8.36,2.223-.767,4.714-3.86,2.406-.858,2.518.389,2.05,1.184Z",
    transform: "translate(-235.91 -303.18)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M303.3,342.365a16.279,16.279,0,0,1-7.884-2.523l.113-.167c.058.039,5.851,3.871,10.773,1.952a14.92,14.92,0,0,0,4.309-2.842,10.89,10.89,0,0,1,4.171-2.588,6.239,6.239,0,0,1,5.57,1.251c1.353,1.112,4.047,2.9,6.893,2.363a9.15,9.15,0,0,0,3.968-2.454c2.482-2.151,5.049-4.375,9.489-1.184l-.118.163c-4.312-3.1-6.817-.927-9.24,1.173a9.315,9.315,0,0,1-4.062,2.5c-2.927.549-5.678-1.272-7.058-2.405a6.043,6.043,0,0,0-5.39-1.212,10.772,10.772,0,0,0-4.093,2.547,14.977,14.977,0,0,1-4.365,2.876A8.421,8.421,0,0,1,303.3,342.365Z",
    transform: "translate(-271.086 -319.326)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.12,
    cy: 1.12,
    r: 1.12,
    transform: "translate(45.116 15.569)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(46.596 1.699)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M528.893,202H514.769a.229.229,0,0,0-.229.229v9.552a.229.229,0,0,0,.4.157l2.448-2.611a.229.229,0,0,1,.167-.072h11.343a.229.229,0,0,0,.229-.229v-6.8A.229.229,0,0,0,528.893,202Z",
    transform: "translate(-514.54 -202)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.043,
    height: 1.006,
    transform: "translate(49.872 3.442)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 2.208,
    height: 1.006,
    transform: "translate(49.831 5.707)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 34.754)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 36.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 38.705)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 40.682)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 42.657)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 44.633)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 46.609)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(28.045 48.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(32.27 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(36.222 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(40.175 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(44.126 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(48.079 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(52.031 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(55.983 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(59.935 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(63.888 49.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 1.006
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 3.353,
    height: 1.006,
    transform: "translate(54.604 5.707)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 6.305,
    transform: "translate(32.27 42.247)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 9.222,
    transform: "translate(36.222 39.319)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 11.669,
    transform: "translate(40.175 36.862)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 10.4,
    transform: "translate(44.126 38.135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 12.608,
    transform: "translate(48.079 35.92)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(52.031 40.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 7.779
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(55.983 40.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 7.779
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(59.935 40.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 7.779
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(63.888 40.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.208,
    height: 7.779
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.687 -32.021)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 6.875,
    cy: 6.875,
    r: 6.875,
    transform: "translate(42.117 4.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M864.622,232.425s.121,3.98-2.533,5.186,10.372,1.085,10.372,1.085-3.859-4.7-2.774-6.272Z",
    transform: "translate(-818.344 -215.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M864.622,232.425s.121,3.98-2.533,5.186,10.372,1.085,10.372,1.085-3.859-4.7-2.774-6.272Z",
    transform: "translate(-818.344 -215.118)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 4.704,
    cy: 4.704,
    r: 4.704,
    transform: "translate(44.228 10.192)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M838.649,254.5l-4.04-.9-2.352,2.472-2.653.362,3.5,14.352-.121,3.618s-3.859,2.895-3.618,16.282-1.93,39.922.724,40.163,8.2,1.447,8.563.362.965-43.9.965-43.9-.121,42.937,1.688,43.419,7.357,1.447,8.081-.121,0-42.454,0-42.454-.121-10.614-4.463-13.75l-.482-2.774,3.739-15.2h-3.015l-1.809-3.136-3.739,1.327Z",
    transform: "translate(-790.32 -232.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M786.12,370.725l-5.169,8.721s-3.781,3.879-1.889,4.951,3.9-4.517,3.9-4.517l5.562-7.322Z",
    transform: "translate(-747.646 -332.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M955.281,371.959l4.18,9.236s3.332,4.271,1.333,5.128-3.384-4.918-3.384-4.918l-4.724-7.889Z",
    transform: "translate(-895.631 -333.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M822.337,275l-1.568-.844s-2.774,4.583-2.292,12.3c0,0-.483,4.1.482,4.342s3.739.724,3.86.241,1.568-9.408,1.568-9.408Z",
    transform: "translate(-781.487 -250.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M940.2,274.764l1.447-.6a8.687,8.687,0,0,1,1.93,4.463c.362,2.774,2.05,11.7.724,11.94s-4.463.724-4.463,0-1.085-9.166-1.085-9.166Z",
    transform: "translate(-883.786 -250.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M796.609,60.626,793.121,58.8l-4.818.748-1,4.4,2.481-.1.693-1.618v1.591l1.145-.044.664-2.575.415,2.741,4.07-.083Z",
    transform: "translate(-743.08 -49.963)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 2.774,
    cy: 2.774,
    r: 2.774,
    transform: "translate(46.579 0.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M873.39,120.025a2.775,2.775,0,0,1,2.352-2.742,2.774,2.774,0,1,0,0,5.484A2.775,2.775,0,0,1,873.39,120.025Z",
    transform: "translate(-827.535 -117.251)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 82.199,
    height: 0.301,
    transform: "translate(0 99.699)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.515,
    cy: 1.515,
    r: 1.515,
    transform: "translate(75.021 93.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1057.57,730.989a4.375,4.375,0,1,1,4.375-4.375A4.375,4.375,0,0,1,1057.57,730.989Zm0-8.414a4.039,4.039,0,1,0,4.039,4.039A4.039,4.039,0,0,0,1057.57,722.575Z",
    transform: "translate(-981.034 -631.326)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7.814,
    height: 7.814,
    transform: "translate(75.744 45.812) rotate(104.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1002.509,448.886a1.8,1.8,0,1,1,2.323,1.052A1.8,1.8,0,0,1,1002.509,448.886Zm3.094-1.166a1.5,1.5,0,1,0-.876,1.936A1.5,1.5,0,0,0,1005.6,447.72Z",
    transform: "translate(-937.867 -396.978)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 2.555,
    cy: 1.352,
    rx: 2.555,
    ry: 1.352,
    transform: "translate(40.874 97.098)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 2.555,
    cy: 1.352,
    rx: 2.555,
    ry: 1.352,
    transform: "translate(52.595 97.098)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUsage);
export default __webpack_public_path__ + "static/media/menu-usage.cfc2857717634f224cf31bcb416e8ebb.svg";
export { ForwardRef as ReactComponent };